<template>
  <div class="messageManagementList">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="queryData">
          <!-- <el-input
            style="width: 150px"
            placeholder="请输入内容"
            v-model.trim="queryData.like[0][2]"
            @keyup.enter.native="getDataList(true)"
            clearable
          >
          </el-input> -->

          <el-select
            v-model.trim="queryData.eq[0][2]"
            class="inputS"
            placeholder="状态"
            @change="getDataList(true)"
            clearable
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="success" @click="getDataList">查询</el-button>
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loadingFlag"
        element-loading-text="正在拼命加载中"
        element-loading-spinner="el-icon-loading"
        stripe
      >
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="userName" label="名称" min-width="150">
        </el-table-column>
        <el-table-column prop="mobile" label="联系方式" min-width="150">
        </el-table-column>
           <el-table-column prop="province" label="所在省份" min-width="150">
        </el-table-column>
        <el-table-column prop="descStr" label="内容" min-width="150">
           <template slot-scope="scope">
              <el-popover
                placement="top-start"
                width="500"
                trigger="hover"
                :content="scope.row.descStr"
              >
                <el-button slot="reference" size="small" type="primary"
                  >查看</el-button
                >
              </el-popover></template
            >
        </el-table-column>
        <!-- <el-table-column prop="sort" label="排序" min-width="50">
        </el-table-column> -->
        <el-table-column prop="status" label="状态" min-width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1">未处理</el-tag>
            <el-tag type="success" v-if="scope.row.status == 2">已处理</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="180">
          <template slot-scope="scope">
            <div>{{ VueDateFormat(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.status == 1"
              @click="addOrEditPopup(scope.row.id)"
              >设为已处理</el-button
            >
            <el-button v-else type="text">已处理</el-button>
            <span class="operationLine">|</span>
            <el-button type="text" @click="baseDeleteById(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="getDataListSizeChange"
        @current-change="getDataListCurrentChange"
        :current-page="queryData.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      queryData: {
        current: 1,
        size: 10,
        // like: [["String", "field_Name", ""]],
        eq: [["String", "status", ""]],
        orderBy: [["String", "create_time", "false"]],
      },
      total: 0,
      centerDialogVisible: false,
      loadingFlag: false,
      dataForm: {},
      statusList: [
        {
          label: "未处理",
          value: 1,
        },
        {
          label: "已处理",
          value: 2,
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.getDataList();
  },
  methods: {
    addOrEditPopup(id) {
      this.$prompt("请输入备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          console.log(value)
          let postData = {
            id: id,
            status: 2,
            remark: value,
          };
          if (!value) {
            this.$VueMessage({
              type: "warning",
              message: "未填写备注",
            });
            return;
          }
          this.$http
            .post(`/kr-leave-msg/saveOrUpdate`, postData)
            .then((res) => {
              if (res.data.code == 200) {
                this.getDataList();
                this.$VueMessage({
                  type: "success",
                  message: "操作成功!",
                });
              } else {
                this.$VueMessage({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
      return;
    },
    /**
     * 删除数据
     */
    baseDeleteById(id) {
      if (id) {
        this.$confirm("是否删除所选择的数据?", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$http
              .delete(`/kr-leave-msg/baseDeleteById/${id}`)
              .then((res) => {
                if (res.data.code == 200) {
                  this.getDataList(true);
                  this.$VueMessage({
                    type: "success",
                    message: "删除成功!",
                  });
                } else {
                  this.$VueMessage({
                    message: res.data.msg,
                    type: "warning",
                  });
                }
              });
          })
          .catch(() => {
            this.$VueMessage({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 查询
    getDataList(flag) {
      let data = this.queryData;
      if (flag) data.current = 1;
      this.loadingFlag = true;
      this.$http
        .post(`/kr-leave-msg/page`, this.$guolv(this.queryData))
        .then((res) => {
          this.loadingFlag = false;
          if (res.data.code == 200) {
            let data = res.data.data;
            if (data) {
              let list = data.records;
              this.tableData = list;
              this.total = data.total;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDataListSizeChange(val) {
      this.queryData.size = val;
      this.getDataList(true);
    },
    getDataListCurrentChange(val) {
      this.queryData.current = val;
      this.getDataList();
    },
  },
};
</script>

